import React, { useState } from "react"
import dataTermsLinks from '../../../data-terms-liks/dataTermsLinks.json'
import '../../assets/stylesheets/quests.scss'

const FaqItem = ({item, index}) => {
    const links = dataTermsLinks[item.terms.termLinks] || null
    const [expanded, setExpanded] = useState(index === 0 ? true : false)
    const useExpand = index > 0 ? true : false;
    const titleClass = index > 0 ? 'faq-title-big' : 'faq-title-small';

    const swapExpanded = () => {
        setExpanded(!expanded)
    }

    return (
        <>
            {links && item.terms && item.terms.number >= 0 && Object.keys(item.terms).length > 0 && (
                <div className="slds-m-bottom_x-large slds-text-align_center">
                    {(useExpand && (
                        <button className={`btn-expand ${titleClass} ${expanded ? 'expanded' : ''}`} aria-controls={`faq-item-details_${index}`} aria-expanded={expanded ? 'true' : 'false'} onClick={swapExpanded}>
                            <svg className="expand-icon slds-m-left_medium slds-m-right_x-small" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                <path d="M47.6 17.8L27.1 38.5c-.6.6-1.6.6-2.2 0L4.4 17.8c-.6-.6-.6-1.6 0-2.2l2.2-2.2c.6-.6 1.6-.6 2.2 0l16.1 16.3c.6.6 1.6.6 2.2 0l16.1-16.3c.6-.6 1.6-.6 2.2 0l2.2 2.2c.5.7.5 1.6 0 2.2z"></path>
                            </svg>
                            <sup>{item.terms.number > 0 ? item.terms.number : '*'} </sup><span>{item.title}</span>
                        </button>
                    )) || (
                        <div className={`btn-expand ${titleClass}`}>
                            <sup>{item.terms.number > 0 ? item.terms.number : '*'} </sup><span>{item.title}</span>
                        </div>
                    )}
                    
                    <div id={`faq-item-details_${index}`} className={`faq-description ${expanded ? 'slds-block' : 'slds-hide'}`}>
                        <span dangerouslySetInnerHTML={{__html: item.terms.text}} />&nbsp;
                        
                        {links.map((link, index2) => (
                            <span key={`terms-link-${index2}`}>
                                <a href={link.url} target="_blank" rel="noreferrer">{link.language}</a>
                                <span style={{display: (index2+1 < links.length) ? 'inline' : 'none'}}> | </span> 
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </>
    )
}

export default FaqItem
